export enum ServiceType {
    Transient,
    Singleton
}